var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge-container"},[(!(this.text === 0 || this.text === '0'))?_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"alert-badge",class:{ 'alert-badge-position-relative': _vm.position === 'relative' },style:({
      right: ((this.xOffset) + "px"),
      top: ("-" + (this.yOffset) + "px"),
    }),attrs:{"variant":_vm.variant}},[_vm._t("badge",[_vm._v(_vm._s(_vm.text))])],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ada68b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/Badge.vue
// module id = null
// module chunks = 